<template>
  <b-img
    fluid
    :src="isPharmacyAccount && getValueFromSource(pharmacyProfile, 'avatar.path') 
    ? getValueFromSource(pharmacyProfile, 'avatar.path') 
    : isLabAccount && getValueFromSource(labProfile, 'avatar.path') 
    ? getValueFromSource(labProfile, 'avatar.path') 
    : logoImage"
    alt="Login V2"
    :width="width"
  />
</template>

<script>
import LogoImage from '@/assets/images/logo/new_logo.png'
import {
  BImg,
} from 'bootstrap-vue'

export default {
  components: {
    BImg,
  },
  props: {
    width: {
      type: String,
      default: "300"
    }
  },
  
  data() {
    return {
      logoImage: LogoImage
    }
  },
}
</script>
